import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const SuratPeringatan = ({ token }) => {
  const { siswaId } = useParams();
  const [siswa, setSiswa] = useState(null);
  const [poinList, setPoinList] = useState([]);
  const [totalPoin, setTotalPoin] = useState(0);

  useEffect(() => {
    // 1. Ambil Data Siswa
    axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/siswa/${siswaId}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setSiswa(res.data))
      .catch(err => console.error(err));

    // 2. Ambil Riwayat Poin
    axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/poin/${siswaId}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        const pelanggaran = res.data.filter(p => p.jenis === 'pelanggaran');
        setPoinList(pelanggaran);
        // Hitung total poin
        const total = pelanggaran.reduce((sum, item) => sum + item.poin, 0);
        setTotalPoin(total);
      })
      .catch(err => console.error(err));
  }, [siswaId, token]);

  if (!siswa) return <div style={{padding:'20px'}}>Memuat data surat...</div>;

  // Tentukan Jenis Surat berdasarkan Poin
  let judulSurat = "SURAT PEMBERITAHUAN POIN";
  let perihal = "Laporan Poin Siswa";
  
  if (totalPoin >= 100) {
    judulSurat = "SURAT PERINGATAN KE-3 (SP3)";
    perihal = "Panggilan Orang Tua (Skorsing/Drop Out)";
  } else if (totalPoin >= 50) {
    judulSurat = "SURAT PERINGATAN KE-2 (SP2)";
    perihal = "Panggilan Orang Tua (Pembinaan)";
  } else if (totalPoin >= 25) {
    judulSurat = "SURAT PERINGATAN KE-1 (SP1)";
    perihal = "Pemberitahuan Poin Pelanggaran";
  }

  return (
    <div style={{ background: '#525659', minHeight: '100vh', padding: '20px', display: 'flex', justifyContent: 'center' }}>
      
      {/* KERTAS A4 */}
      <div className="kertas-a4" style={{ background: 'white', width: '210mm', minHeight: '297mm', padding: '25mm', boxShadow: '0 0 10px rgba(0,0,0,0.5)', position: 'relative' }}>
        
        {/* TOMBOL PRINT (Hilang pas diprint) */}
        <div className="no-print" style={{ position: 'absolute', top: '20px', right: '20px' }}>
          <button 
            onClick={() => window.print()}
            style={{ background: '#4361ee', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
          >
            🖨️ Cetak Surat
          </button>
        </div>

        {/* 1. KOP SURAT */}
        <div style={{ borderBottom: '3px double black', paddingBottom: '10px', marginBottom: '20px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>
            {/* Logo (Emoji dulu, nanti bisa ganti gambar) */}
            <div style={{ fontSize: '50px' }}>🎓</div>
            <div>
                <h3 style={{ margin: 0, fontSize: '18px', textTransform: 'uppercase' }}>Pemerintah Aceh</h3>
                <h2 style={{ margin: '5px 0', fontSize: '22px', textTransform: 'uppercase' }}>SMA NEGERI 10 FAJAR HARAPAN</h2>
                <p style={{ margin: 0, fontSize: '12px', fontStyle: 'italic' }}>Jl. Fajar Harapan No. 1, Banda Aceh. Telp: (0651) 123456</p>
            </div>
        </div>

        {/* 2. HEADER SURAT */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <h3 style={{ textDecoration: 'underline', margin: '0 0 5px 0' }}>{judulSurat}</h3>
            <p style={{ margin: 0 }}>Nomor: 421 / ..... / BK / {new Date().getFullYear()}</p>
        </div>

        {/* 3. ISI SURAT */}
        <div style={{ fontSize: '14px', lineHeight: '1.6', textAlign: 'justify' }}>
            <p>Yth. Bapak/Ibu Orang Tua/Wali dari:</p>
            
            <table style={{ margin: '10px 0 20px 20px', border: 'none' }}>
                <tbody>
                    <tr><td width="120">Nama Siswa</td><td>: <strong>{siswa.nama}</strong></td></tr>
                    <tr><td>NIS</td><td>: {siswa.nis}</td></tr>
                    <tr><td>Kelas</td><td>: {siswa.kelas}</td></tr>
                    <tr><td>Total Poin</td><td>: <strong>{totalPoin} Poin</strong></td></tr>
                </tbody>
            </table>

            <p>
                Dengan hormat,<br/>
                Berdasarkan data ketertiban sekolah, kami memberitahukan bahwa putra/putri Bapak/Ibu 
                telah melakukan pelanggaran tata tertib sekolah dengan rincian sebagai berikut:
            </p>

            {/* TABEL PELANGGARAN */}
            <table style={{ width: '100%', borderCollapse: 'collapse', margin: '20px 0', fontSize: '13px' }}>
                <thead>
                    <tr style={{ background: '#f1f5f9' }}>
                        <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', width: '30px' }}>No</th>
                        <th style={{ border: '1px solid black', padding: '8px' }}>Tanggal</th>
                        <th style={{ border: '1px solid black', padding: '8px' }}>Jenis Pelanggaran</th>
                        <th style={{ border: '1px solid black', padding: '8px', width: '50px' }}>Poin</th>
                    </tr>
                </thead>
                <tbody>
                    {poinList.map((item, idx) => (
                        <tr key={item.id}>
                            <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{idx + 1}</td>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{item.tanggal}</td>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{item.keterangan}</td>
                            <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center', fontWeight: 'bold' }}>{item.poin}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <p>
                Sehubungan dengan hal tersebut (Perihal: <b>{perihal}</b>), kami mohon kehadiran Bapak/Ibu 
                untuk membicarakan pembinaan putra/putri Bapak/Ibu pada:
            </p>

            <table style={{ margin: '10px 0 20px 20px', border: 'none' }}>
                <tbody>
                    <tr><td width="100">Hari/Tanggal</td><td>: ........................................................</td></tr>
                    <tr><td>Pukul</td><td>: 09.00 WIB s.d Selesai</td></tr>
                    <tr><td>Tempat</td><td>: Ruang Bimbingan Konseling (BK)</td></tr>
                </tbody>
            </table>

            <p>Demikian surat ini kami sampaikan. Atas perhatian dan kerjasamanya kami ucapkan terima kasih.</p>
        </div>

        {/* 4. TANDA TANGAN */}
        <div style={{ marginTop: '50px', display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
            <div style={{ textAlign: 'center' }}>
                <p>Mengetahui,<br/>Orang Tua/Wali</p>
                <br/><br/><br/><br/>
                <p>( .................................... )</p>
            </div>
            
            <div style={{ textAlign: 'center' }}>
                <p>Banda Aceh, {new Date().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}<br/>Guru BK / Wali Kelas</p>
                <br/><br/><br/><br/>
                <p>( .................................... )</p>
            </div>
        </div>

      </div>

      {/* CSS KHUSUS PRINT */}
      <style>{`
        @media print {
          body * { visibility: hidden; }
          .kertas-a4, .kertas-a4 * { visibility: visible; }
          .kertas-a4 { position: absolute; left: 0; top: 0; width: 100%; box-shadow: none; margin: 0; padding: 20mm !important; }
          .no-print { display: none !important; }
          @page { size: auto; margin: 0mm; }
        }
      `}</style>

    </div>
  );
};

export default SuratPeringatan;